export const CHANGE_STAGE = 'changeStageFloorplan';
export const SET_ACTIVE_SLIDE = 'changeActiveSlideFloorplan';
export const SET_MAP_POSITION = 'setMapPositionFloorplan';
export const SET_ZOOM_CONTROL_POSITION = 'setZoomControlPositionFloorplan';
export const SET_ZOOM = 'setZoomFloorplan';
export const SET_ACTIVE_SLIDER = 'setActiveSliderFloorplan';
export const TOGGLE_VISIBILITY = 'toggleVisibilityFloorplan';
export const TRIGGER_AUTOHIDE = 'triggerAutohideFloorplan';